import React from 'react'
import { Dialog, DialogContent, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
// import CloseIcon from '@material-ui/icons/Close'
import Cancel from '@material-ui/icons/Cancel'

const styles = () => ({
  closeButtonContainer: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#999',
    zIndex: 10,
    '&:hover': {
      color: '#000'
    }
  },
  closeButton: {
    fontWeight: 600,
    height: '25px',
    width: '25px',
    color: '#F67131'
  }
})

const ModalComponent = ({
  open,
  onClose,
  content,
  maxWidth,
  classes,
  isFullScreen
}) => {
  const width = maxWidth || '500px'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isFullScreen}
      PaperProps={{
        style: {
          margin: isFullScreen ? '32px' : '0 auto',
          maxHeight: isFullScreen && 'calc(100% - 2 * 32px)',
          maxWidth: width,
          position: 'relative',
          overflow: 'visible',
          padding: 0
        }
      }}
    >
      <IconButton className={classes.closeButtonContainer} onClick={onClose}>
        <Cancel className={classes.closeButton} />
      </IconButton>
      <DialogContent style={{ padding: 0 }}>{content}</DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(ModalComponent)
